<script>
export default {
  name: 'TeamNewUxIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: '#368B57',
    },
    insideColor: {
      type: String,
      default: '#fff',
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.53 7.77C17.46 7.76 17.39 7.76 17.32 7.77C15.77 7.72 14.54 6.45 14.54 4.89C14.54 3.3 15.83 2 17.43 2C19.02 2 20.32 3.29 20.32 4.89C20.31 6.45 19.08 7.72 17.53 7.77Z"
      :fill="color"
    />
    <path
      d="M20.79 14.7004C19.67 15.4504 18.1 15.7304 16.65 15.5404C17.03 14.7204 17.23 13.8104 17.24 12.8504C17.24 11.8504 17.02 10.9004 16.6 10.0704C18.08 9.8704 19.65 10.1504 20.78 10.9004C22.36 11.9404 22.36 13.6504 20.79 14.7004Z"
      :fill="color"
    />
    <path
      d="M6.44003 7.77C6.51003 7.76 6.58003 7.76 6.65003 7.77C8.20003 7.72 9.43003 6.45 9.43003 4.89C9.43003 3.29 8.14003 2 6.54003 2C4.95003 2 3.66003 3.29 3.66003 4.89C3.66003 6.45 4.89003 7.72 6.44003 7.77Z"
      :fill="color"
    />
    <path
      d="M6.55 12.8506C6.55 13.8206 6.75999 14.7406 7.14 15.5706C5.73 15.7206 4.26 15.4206 3.18 14.7106C1.6 13.6606 1.6 11.9506 3.18 10.9006C4.25 10.1806 5.75999 9.89059 7.18 10.0506C6.77 10.8906 6.55 11.8406 6.55 12.8506Z"
      :fill="color"
    />
    <path
      d="M12.12 15.87C12.04 15.86 11.95 15.86 11.86 15.87C10.02 15.81 8.55005 14.3 8.55005 12.44C8.56005 10.54 10.09 9 12 9C13.9 9 15.44 10.54 15.44 12.44C15.43 14.3 13.97 15.81 12.12 15.87Z"
      :fill="color"
    />
    <path
      d="M8.87005 17.9406C7.36005 18.9506 7.36005 20.6106 8.87005 21.6106C10.59 22.7606 13.41 22.7606 15.13 21.6106C16.64 20.6006 16.64 18.9406 15.13 17.9406C13.42 16.7906 10.6 16.7906 8.87005 17.9406Z"
      :fill="color"
    />
  </svg>
</template>
